export const NEW_USER = "NEW_USER";
export const VERIFY_USER = "VERIFY_USER";
export const PROCESS_CONFIRM = "PROCESS_CONFIRM";
export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const DEAUTHENTICATE_USER = "DEAUTHENTICATE_USER";
export const NEW_MEMBER = "NEW_MEMBER";
export const NEW_MEMBER_ADMIN = "NEW_MEMBER_ADMIN";
